import { configure, defineRule } from "vee-validate";
import { Form, Field, ErrorMessage } from "vee-validate";
import * as rules from "@vee-validate/rules";
import { i18nGlobal as i18n } from "@/i18n";
import { App } from "vue";

export default (app: App) => {
  app.component("Form", Form);
  app.component("Field", Field);
  app.component("ErrorMessage", ErrorMessage);

  Object.keys(rules)
    .filter((k) => !["default", "all"].includes(k))
    .forEach((rule) => {
      defineRule(rule, (rules as any)[rule]);
    });

  defineRule("create_basic_auth", (value: string) =>
    /^[a-zA-Z0-9(\!\"\#\$\%\&\'\(\)*+,-\.\/\:\;\<\=\>\?\@\[\\\]\^\_\`\{\|\}\~)]*$/.test(value),
  );

  defineRule("max_tree_search", (value: string) => value.length <= 600);

  defineRule("max_password", rules.max);
  defineRule("min_password", rules.min);

  defineRule("required_select_page", rules.required);
  defineRule("at_least_one_lowercase_letter", (value: string) => /^.*[a-z].*$/.test(value));
  defineRule("at_least_one_uppercase_letter", (value: string) => /^.*[A-Z].*$/.test(value));
  defineRule("at_least_one_number", (value: string) => /^.*[0-9].*$/.test(value));
  defineRule("cognito_password_allow_characters", (value: string) =>
    /^[a-zA-Z0-9\^$*.\[\]{}\(\)?\-“!@#%&/,><\’:;|_~`]*$/.test(value),
  );
  defineRule("search_string_max_length", (value: string) => {
    return value.length <= 100;
  });

  defineRule("not_allow_space_only", (value: string) => {
    if (value.length === 0) {
      return true;
    }
    return value.trim().length > 0;
  });

  configure({
    generateMessage: (ctx) => {
      const { field, rule } = ctx;
      const params: Record<string, any> = {
        _field_: i18n.t(`fields.${field}`),
        _special_character_: " ! \" # $ % & ' ( ) * + , - . / : ; < = > ? @ [ \\ ] ^ _ ` { | } ~",
      };

      if (rule && rule.name) {
        if (["max", "min"].includes(rule.name)) {
          params.length = (rule as any).params[0];
        }
        return i18n.t(`validation.${rule.name}`, params) || `${field} is invalid`;
      }
      return i18n.t(field, params);
    },
  });
};
